<template>
  <span>
    {{ isCleared ? 'removed' : 'changed' }}
    {{ fieldDefinition.name }}
    <template v-if="isUpdated && !isSet">
      from
      <user-short
        class="user-field bold"
        :user-id="event.changes.old"
        :length="20"
        :show-user-name="true"
        v-if="fieldDefinition.type === CUSTOM_FIELD_TYPE.USER"
      />
      <template v-else>
        <span class="bold">{{ event.changes.old }}</span>
      </template>
    </template>
    <template v-if="isUpdated">
      to
      <user-short
        class="user-field bold"
        :user-id="event.changes.new"
        :length="20"
        :show-user-name="true"
        v-if="fieldDefinition.type === CUSTOM_FIELD_TYPE.USER"
      />
      <template v-else>
        <span class="bold">{{ event.changes.new }}</span>
      </template>
    </template>
  </span>
</template>

<script>
import UserShort from '@/components/UserShort'
import { CUSTOM_FIELD_TYPE } from '@/constants/customFields'
import getIdFromCFPrefixedField from '@/utils/initiative/getIdFromCFPrefixedField'
import * as R from 'ramda'

/**
 * This shows the event title for custom_field_changed events.
 */
export default {
  name: 'InitiativeCfChangedEventTitle',
  props: ['event'],
  components: {
    UserShort
  },
  data() {
    return {
      CUSTOM_FIELD_TYPE
    }
  },
  computed: {
    orgCFs() {
      return this.$store.state.orgCustomFields[this.event.organizationId]
    },
    isSet() {
      return R.isNil(this.event.changes.old) && !R.isNil(this.event.changes.new)
    },
    isCleared() {
      return !R.isNil(this.event.changes.old) && R.isNil(this.event.changes.new)
    },
    isUpdated() {
      return !R.isNil(this.event.changes.new)
    },
    fieldId() {
      return getIdFromCFPrefixedField(this.event.field)
    },
    fieldDefinition() {
      return this.orgCFs.find(field => field.id === this.fieldId)
    }
  },
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
.user-field {
  transform: translateY(4px);
}
</style>
